<h2 mat-dialog-title>Filter Documents</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="filterForm" class="filter-form">
    <div class="date-range">
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="endDate">
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let status of statuses" [value]="status">{{status}}</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="checkbox-container">
      <mat-checkbox formControlName="myDocuments">My Documents</mat-checkbox>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onClear()">Clear</button>
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onApply()">Apply</button>
</mat-dialog-actions>
